// Core
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation, NavLink, Link } from 'react-router-dom';
import {
  Button,
  Box,
  Flex,
  Grid,
  Text,
  Image,
  useColorModeValue,
  useColorMode
} from '@chakra-ui/react';

// Accets
import { getInitials, formatDateWithSuffix, validateLoadMore, parseNotifyDate } from 'services/Utils';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';
import { ReactComponent as LinesWhite } from 'assets/svg/lines-white.svg';
import { ReactComponent as GarageIcon } from 'assets/svg/wallet/slider/garage.svg';
import { ReactComponent as MarketplaceIcon } from 'assets/svg/wallet/slider/marketplace.svg';
import { ReactComponent as WheelIcon } from 'assets/svg/wallet/slider/wheel.svg';
import { ReactComponent as GiveawaysEntriesIcon } from 'assets/svg/wallet/slider/entries.svg';
import { ReactComponent as MerchIcon } from 'assets/svg/wallet/slider/merch.svg';
import gemImage from 'assets/img/details/gem.png';
import gemBlurImage from 'assets/img/details/gem-blur.png';
import coinImage from 'assets/img/details/coin-1.png';

// Components
import Card from 'components/Card/Card';
import CoinsSpend from 'components/Sliders/CoinsSpend';

const Balance = ({ userData }) => {
	const bg = useColorModeValue('white', '#0A1027');
	const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
	const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');
	const textColor = useColorModeValue('#262D47 !important', 'rgb(159, 171, 203) !important');
	const textShadow = useColorModeValue('unset', '1px 1px black');
	const dividerDark = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 42.74%, #FFF 50.39%, #38A9E1 57.37%, rgba(56, 169, 225, 0.00) 100%)';
	const dividerWhite = 'linear-gradient(90deg, rgba(56, 169, 225, 0.00) 0%, #38A9E1 3.65%, #38A9E1 8.19%, #38A9E1 13.55%, rgba(56, 169, 225, 0.00) 100%)';
	const divider = useColorModeValue(dividerWhite, dividerDark);

	const { colorMode } = useColorMode();
	const isDark = colorMode === 'dark';

	const balance = userData?.cashbackBalance;

	const titleStyle = {
		color: '#9FABCB',
		fontSize: '13px',
		fontStyle: 'normal',
		fontWeight: '500',
		lineHeight: '18px',
		letterSpacing: '-0.4px',
		textTransform: 'uppercase',
		marginBottom: '8px',
		zIndex: '2'
	};

	const sumStyle = {
		fontStyle: 'normal',
		fontWeight: '900',
		lineHeight: 'normal',
		letterSpacing: '-0.4px',
		zIndex: '2'
	};

	const sliderData = [
		{
			icon: GarageIcon,
			title: 'Garage Tickets', 
			description: 'Play Garage game to get even more bonuses!',
			comingSoon: false
		},
		{
			icon: MarketplaceIcon,
			title: 'Marketplace', 
			description: 'Redeem awesome Rewards from our Partners!',
			comingSoon: false
		},
		{
			icon: WheelIcon,
			title: 'Bonus wheel', 
			description: 'Spin the wheel and win instant rewards!',
			comingSoon: false
		},
		{
			icon: GiveawaysEntriesIcon,
			title: 'LMCT+ Coin Draws', 
			description: 'Turn your LMCT+ Coins into real chances to win!',
			comingSoon: false
		},
		{
			icon: MerchIcon,
			title: 'Merch Store', 
			description: 'Get a discount on the awesome LMCT+ Merch Store products!',
			comingSoon: true
		},
	];

	return (
		<Card display={ userData ? 'block' : 'none'} padding="0" bg={bg} border={border} boxShadow={boxShadow} mb="16px" overflow="hidden">
			<Box padding={{base: '16px'}}>
				<Card padding="12px" bg={bg} border={border} boxShadow={boxShadow} overflow="hidden">
					<Text zIndex="2" style={titleStyle} textShadow={textShadow} color={textColor}>Your LMCT+ Coins</Text>
					<Text zIndex="2" variant="title-lg" style={sumStyle} textShadow={textShadow} fontSize={{base: '24px', md: '32px'}}>
						{balance?.toLocaleString()}
					</Text>

					{ isDark ? <Lines className="abstract-lines" style={{ zIndex: '1', top: '-138px', left: '40px'}} />
					: <LinesWhite className="abstract-lines" style={{ zIndex: '1', opacity: 0.3, top: '-138px', left: '40px' }} /> }
					{ isDark && <Box position="absolute" 
						bg="#099BFF" 
						filter="blur(40px)" 
						w="50%" h="20px" position="absolute" 
						bottom="-20px" left="0" /> }

					<Box zIndex="1" position="absolute" top="0" right="0px" h="100%" w="100%" className="animation-balance-coins">
						<Image className="animation-balance-coins-gem" src={gemImage} alt="Gem" position="absolute" 
							zIndex="2" right="-6px" top="31px" w="60px" />
            <Image className="animation-balance-coins-gem-blur" src={gemBlurImage} alt="Gem Blur" position="absolute" 
            	zIndex="2" right="107px" top="42px" w="60px" />
            <Image className="animation-balance-coins-gem-coin" src={coinImage} alt="Coin" position="absolute" 
            	zIndex="1" right="-15px" top="-45px" w="170px" transform="rotate(25deg)" />
					</Box>

					<Box 
						w="100%"
						h="2px"
						bg={divider}
						position="absolute"
						bottom="0" />
				</Card>
			</Box>

			<Text p="0 16px" style={titleStyle} textShadow={textShadow} color={textColor} mb="8px">Where to spend bonuses</Text>

			<CoinsSpend data={sliderData} />
		
		</Card>
	);
};

export default Balance;